import { format } from 'date-fns';
import MemoArrow from '../../icons/Arrow';

/**
 * Displays a single case note from Algolia
 */
export interface HubSearchResultProps {
  note: any;
  onClick: (e: any) => void;
  showDate?: boolean;
}

const HubSearchResult: React.FC<HubSearchResultProps> = ({
  note,
  onClick,
  showDate,
}) => {
  let singularName = window.hub_search_props?.title || 'case study';

  // remove the plural from the singular name
  if (singularName.endsWith('s')) {
    singularName = singularName.slice(0, -1);
  }

  let tags = null;
  let meta = null;
  if (note.Tags) {
    meta = note.Tags;
  } else if (note.Topics) {
    meta = note.Topics;
  }

  if (meta) {
    tags = (
      <span>
        {meta.length > 0 &&
          meta.map((tag, i) => {
            const isLast = i === meta.length - 1;
            return (
              <span key={tag.objectID} className="case-note__tag">
                {tag.objectTitle}
                {!isLast && ', '}
              </span>
            );
          })}
      </span>
    );
  }

  let date = null;

  if (note.CaseDate) {
    date = new Date(note.CaseDate * 1000);
  } else if (note.Date) {
    date = new Date(note.Date * 1000);
  }

  const formattedDate = date ? format(date, 'MMM yyyy') : null;

  let excerpt = '';

  if (note.IntroText) {
    excerpt = note.IntroText;
  } else if (note.BannerContent) {
    excerpt = note.BannerContent;
  } else if (note.Content) {
    excerpt = note.Content;
  }

  // limit the excerpt to 200 characters
  if (excerpt.length > 200) {
    excerpt = `${excerpt.substring(0, 200)}...`;
  }

  let divider = '';

  if (meta && meta.length > 0 && formattedDate) {
    divider = '•';
  }

  // fix &#039; to '
  excerpt = excerpt.replace(/&#039;/g, "'");

  // fix other html entities
  excerpt = excerpt.replace(/&quot;/g, '"');
  excerpt = excerpt.replace(/&amp;/g, '&');

  // remove all html tags
  excerpt = excerpt.replace(/<[^>]*>?/g, '');

  return (
    <li className="case-note">
      <hgroup>
        {showDate ? (
          <p>
            {formattedDate} {divider} {tags}
          </p>
        ) : (
          <p>{tags}</p>
        )}
        <h2>
          <a href={note.objectLink}>{note.objectTitle}</a>
        </h2>
      </hgroup>
      <p>{excerpt}</p>

      <a href={note.objectLink} className="case-note__link" onClick={onClick}>
        Read full {singularName} <MemoArrow />
      </a>
    </li>
  );
};

export default HubSearchResult;
